"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = require("../Button");

var _Flex = require("../Flex");

var _Modal = require("../Modal");

var _Spacer = require("../Spacer");

var _Text = require("../Text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dialog.
 * @deprecated: Use `ModalDialog` instead
 */
var Dialog = function Dialog(_ref) {
  var title = _ref.title,
      detail = _ref.detail,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? true : _ref$show,
      primaryCta = _ref.primaryCta,
      secondaryCta = _ref.secondaryCta,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return null;
  } : _ref$onClose;
  return /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    show: show,
    onClose: onClose,
    modalWidth: _Modal.ModalWidth.Narrow,
    hideCloseButton: true
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "sm-display",
    fontWeight: "bold",
    mb: 1
  }, title), detail && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs",
    color: "black60"
  }, detail)), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    mt: 2,
    justifyContent: "flex-end"
  }, secondaryCta && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: secondaryCta.action,
    size: "small",
    variant: "secondaryBlack"
  }, secondaryCta.text), /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    x: 1
  })), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: primaryCta.action,
    size: "small"
  }, primaryCta.text))));
};

exports.Dialog = Dialog;
Dialog.displayName = "Dialog";
Dialog.displayName = "Dialog";
//# sourceMappingURL=Dialog.js.map